import type { ScheduleDetail } from "@/api/schedule/models";
import { createContext } from "react";

export interface ScheduleActionsContextValue {
  schedule: ScheduleDetail;
}

export const ScheduleActionsContext = createContext<ScheduleActionsContextValue>({} as ScheduleActionsContextValue);

interface Props extends ScheduleActionsContextValue {
  children: React.ReactNode;
}

export const ScheduleActionsProvider = ({ schedule, children }: Props) => {
  return <ScheduleActionsContext.Provider value={{ schedule }}>{children}</ScheduleActionsContext.Provider>;
};
